import { render } from "./AppInfiniteScroll.vue?vue&type=template&id=034af4de&scoped=true"
import script from "./AppInfiniteScroll.vue?vue&type=script&lang=js"
export * from "./AppInfiniteScroll.vue?vue&type=script&lang=js"

import "./AppInfiniteScroll.vue?vue&type=style&index=0&id=034af4de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034af4de"]])

export default __exports__